import axios from "utils/axios";

import { LEADS_FETCH_URL, SEND_ACK_URL } from "config/services";

class LeadsService {

  fetchQuotationLead = async (vendorsIn, userId, rfqId) => {
    const response = await axios.post(LEADS_FETCH_URL, { vendorsIn, userId, rfqId: Number(rfqId) });
    if (response.data?.error || !Array.isArray(response.data?.payload)) {
      throw new Error(response.data?.message || "Failed to load the quotation request");
    }
    return response.data.payload.find((lead) => Number(lead.rfqId) === Number(rfqId)) || null;
  };

  fetchLeads = (vendorsIn, userId, options = {}) =>
    new Promise((resolve, reject) => {

      // console.log("LeadsService.fetchLeads called");

      axios.post(LEADS_FETCH_URL, { vendorsIn, userId, ...options })
        .then((response) => {
          // console.log("LeadsService.fetchLeads() resp:", response)
          if (response?.data?.error) {
            // console.log("Failed to fetch records");
            reject(response.data.message);
          } else {
            if (response?.data?.payload) {
              resolve(response?.data?.payload);
            }
          }
        })
        .catch((error) => {
          if (error.response) {
            // console.log("LeadsService.fetchLeads() error:", error);
            reject(error?.response?.data);
          }
          reject(error);
        });
    });

  sendAckLead = (supplierId, rfqId, viewByName, viewById, acknowledgeDate) =>
    new Promise((resolve, reject) => {
      // console.log("LeadsService.sendAckLead called");
      const payload = { supplierId, rfqId, viewByName, viewById, acknowledgeDate };
      axios
        .post(SEND_ACK_URL, { payload })
        .then((response) => {
          // console.log("LeadsService.fetchLeads() resp:", response)
          if (response?.data?.error) {
            // console.log("Failed to fetch records");
            reject(response.data.message);
          } else {
            if (response?.data?.payload) {
              resolve(response?.data?.payload);
            }
          }
        })
        .catch((error) => {
          if (error.response) {
            // console.log("LeadsService.fetchLeads() error:", error);
            reject(error?.response?.data);
          }
          reject(error);
        });
    });
}

const leadsService = new LeadsService();

export default leadsService;
